<template>
  <q-page class="bg-white q-pa-lg">
    <client-loader :client-id="clientId" v-model="client" />
    <div class="row q-col-gutter-lg">
      <div class="col-12 col-md-4">
        <social-accounts-card :client-id="clientId" />
      </div>
      <div class="col-12 col-md-4">
        <posts-card :client-id="clientId" />
      </div>
      <div class="col-12 col-md-4">
        <albums-card :client-id="clientId" />
      </div>
    </div>
  </q-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { DetailedClient } from '@/type';
import { name } from '@/client/client-filter';
import ClientLoader from '@/client/ClientLoader.vue';
import AuthAccountsMixin from '@/social/account/AuthAccountsMixin';
import SocialAccountsCard from './SocialAccountsCard.vue';
import PostsCard from './PostsCard.vue';
import AlbumsCard from './AlbumsCard.vue';

interface Data {
  client: DetailedClient|null,
}

export default defineComponent({
  meta() {
    return {
      // @ts-ignore
      title: this.pageTitle,
    };
  },
  components: {
    ClientLoader,
    SocialAccountsCard,
    PostsCard,
    AlbumsCard,
  },
  mixins: [AuthAccountsMixin],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      client: null,
    };
  },
  computed: {
    pageTitle(): string {
      return (this.client) ? `${name(this.client)} Dashboard` : 'Client Dashboard';
    },
  },
});
</script>
